// function initMobileSlider() {
//   const slider = $('.product .product__media-list');

//   if (window.innerWidth < 750) {
//     if (!slider.hasClass('slick-initialized')) {
//       slider.slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         fade: true,
//         dots: true
//       });
//     }
//   } else {
//     // Destroy Slick if screen is larger
//     if (slider.hasClass('slick-initialized')) {
//       slider.slick('unslick');
//     }
//   }
// }

// // Run on load
// initMobileSlider();

// // Run on resize
// $(window).on('resize', function () {
//   clearTimeout(window.sliderResizeTimer);
//   window.sliderResizeTimer = setTimeout(initMobileSlider, 200);
// });

// $('.product .product__media-list').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: true,
//   fade: true,
//   dots: true,
//   responsive: [
//     {
//       breakpoint: 750,
//       settings: {
//         arrows: false
//       }
//     }
//   ]
// });
// document.addEventListener("DOMContentLoaded", () => {
//   console.log('script init');
//   const mediaItems = document.querySelectorAll('.product__media-item .media img');
//   function updateOpacity() {
//     mediaItems.forEach(img => {
//       const rect = img.getBoundingClientRect();
//       const windowHeight = window.innerHeight || document.documentElement.clientHeight;

//       // Calculate how much of the image is visible
//       const visibleTop = Math.max(rect.top, 0);
//       const visibleBottom = Math.min(rect.bottom, windowHeight);
//       const visibleHeight = visibleBottom - visibleTop;

//       const totalHeight = rect.height * 0.8;
//       let visibility = visibleHeight / totalHeight;

//       // Clamp between 0.5 and 1
//       visibility = Math.max(0.5, Math.min(1, visibility));

//       img.style.opacity = visibility;
//     });
//   }

//   // Run on scroll and resize
//   window.addEventListener('scroll', updateOpacity);
//   window.addEventListener('resize', updateOpacity);

//   // Initial call
//   updateOpacity();
// });


  $('.product .product__media-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    dots: true,
    responsive: [
      {
       breakpoint: 750,
       settings: {
          arrows: false
       }
     }
   ]
  });



// if (window.innerWidth > 750) {
//   $('.product .product__media-list').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     fade: true,
//     dots: true
//   });
// }